import React, { useState } from "react";
import { FaFolder } from "react-icons/fa6";
import { IoClose } from "react-icons/io5";
import { LuFolderPlus } from "react-icons/lu";

const FOLDER_ICONS = [
  { color: "#6366f1", label: "Default" },
  { color: "#10b981", label: "Green" },
  { color: "#f59e0b", label: "Yellow" },
  { color: "#ef4444", label: "Red" },
  { color: "#a855f7", label: "Purple" },
  { color: "#f97316", label: "Orange" },
  { color: "#06b6d4", label: "Cyan" },
  { color: "#64748b", label: "Gray" },
];

const NewFolderModal = ({ onClose, onSave, isPending = false }) => {
  const [form, setForm] = useState({
    name: "",
    parent: "",
    desc: "",
    icon: 0,
  });

  return (
    <div className="fixed inset-0 z-[999] flex items-center justify-center bg-black/40 backdrop-blur-sm animate-in fade-in duration-150">
      <div className="bg-white rounded-2xl shadow-2xl w-full md:w-1/2 lg:w-1/4 mx-4 animate-in zoom-in-95 duration-150">
        {/* Header */}
        <div className="flex items-center justify-between px-6 pt-6 pb-4 border-b border-slate-100">
          <div className="flex items-center gap-3">
            <div className="w-9 h-9 bg-indigo-50 rounded-xl flex items-center justify-center">
              <LuFolderPlus size={18} className="text-indigo-600" />
            </div>
            <h2 className="text-base font-bold text-slate-900">New Folder</h2>
          </div>
          <button
            onClick={onClose}
            disabled={isPending}
            className="p-1.5 rounded-lg hover:bg-slate-100 text-slate-400 hover:text-slate-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          >
            <IoClose size={18} />
          </button>
        </div>

        {/* Body */}
        <div className="px-6 py-5 space-y-4">
          {/* Folder Name */}
          <div>
            <label className="block text-xs font-semibold text-slate-700 mb-1.5">
              Folder Name <span className="text-red-500">*</span>
            </label>
            <input
              value={form.name}
              disabled={isPending}
              onChange={(e) => setForm({ ...form, name: e.target.value })}
              placeholder="Enter folder name"
              className="w-full px-3 py-2.5 text-sm border border-slate-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-indigo-500/40 focus:border-indigo-400 transition-all placeholder-slate-400 disabled:opacity-60 disabled:cursor-not-allowed"
            />
          </div>

          {/* Parent Folder */}
          {/* <div>
            <label className="block text-xs font-semibold text-slate-700 mb-1.5">
              Parent Folder
            </label>
            <div className="relative">
              <input
                value={form.parent}
                onChange={(e) => setForm({ ...form, parent: e.target.value })}
                placeholder="Select parent folder"
                className="w-full px-3 py-2.5 text-sm border border-slate-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-indigo-500/40 focus:border-indigo-400 transition-all"
              />
              {form.parent && (
                <button
                  onClick={() => setForm({ ...form, parent: "" })}
                  className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 hover:text-slate-600"
                >
                  <IoClose size={14} />
                </button>
              )}
            </div>
          </div> */}

          {/* Description */}
          {/* <div>
            <label className="block text-xs font-semibold text-slate-700 mb-1.5">
              Description{" "}
              <span className="text-slate-400 font-normal">(Optional)</span>
            </label>
            <textarea
              value={form.desc}
              onChange={(e) => setForm({ ...form, desc: e.target.value })}
              placeholder="Enter folder description"
              rows={2}
              className="w-full px-3 py-2.5 text-sm border border-slate-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-indigo-500/40 focus:border-indigo-400 transition-all placeholder-slate-400 resize-none"
            />
          </div> */}

          {/* Folder Icon Picker */}
          {/* <div>
            <label className="block text-xs font-semibold text-slate-700 mb-2">
              Folder Icon
            </label>
            <div className="flex gap-2 flex-wrap">
              {FOLDER_ICONS.map((ic, i) => (
                <button
                  key={i}
                  onClick={() => setForm({ ...form, icon: i })}
                  className={`w-9 h-9 rounded-xl flex items-center justify-center transition-all ${form.icon === i ? "ring-2 ring-offset-1 scale-110" : "hover:scale-105"
                    }`}
                  style={{
                    backgroundColor: `${ic.color}18`,
                    outlineColor: form.icon === i ? ic.color : "transparent",
                  }}
                  title={ic.label}
                >
                  <FaFolder size={16} style={{ color: ic.color }} />
                </button>
              ))}
            </div>
          </div> */}
        </div>

        {/* Footer */}
        <div className="flex items-center justify-end gap-3 px-6 pb-6 pt-4 border-t border-slate-100">
          <button
            onClick={onClose}
            disabled={isPending}
            className="px-4 py-2 text-sm font-semibold text-slate-600 hover:text-slate-800 hover:bg-slate-100 rounded-xl transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          >
            Cancel
          </button>
          <button
            onClick={async () => {
              if (form.name.trim()) {
                try {
                  await onSave(form);
                  onClose();
                } catch (err) {
                  console.error(err);
                }
              }
            }}
            disabled={!form.name.trim() || isPending}
            className="px-5 py-2 text-sm font-semibold bg-indigo-600 hover:bg-indigo-700 text-white rounded-xl transition-colors shadow-sm shadow-indigo-200 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {isPending ? "Creating..." : "Create"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default NewFolderModal;
